import { posts } from "./blogPosts";
import { videos } from "./generatedVideos";

export const resourceItems = [...posts, ...videos].sort((firstItem, secondItem) => new Date(secondItem.date) - new Date(firstItem.date));